<template>
  <v-container v-if="!isMobile" class="d-flex justify-center align-center">
    <div class="text-center">
      <v-dialog v-model="isModalQR" max-width="700" scrollable persistent>
        <v-card style="max-height: 90vh">
          <v-card-text class="pa-0" style="overflow-y: auto">
            <TwoFactorQR
              :setup="twoFactorData"
              :email="loginEmail"
              @cancel="isModalQR = false"
              :user="loggedUser"
              :isMobile="isMobile" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-card class="d-flex px-4" style="margin-top: 8rem" elevation="10" height="100%" width="50%">
      <v-row class="justify-center">
        <div class="ma-2">
          <v-img class="mx-3 pt-5 mt-3" contain max-width="400" :src="logo"></v-img>
        </div>

        <v-card-text class="py-0">
          <v-form @submit.prevent="validateUser()" ref="loginForm" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" class="px-8">
                <v-text-field
                  v-model="loginEmail"
                  label="Email"
                  :rules="nameRules"
                  required
                  autocomplete="email"
                  data-cy="email" />
              </v-col>

              <v-col cols="12" class="px-8">
                <v-text-field
                  v-model="loginPassword"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (showPassword = !showPassword)"
                  :type="showPassword ? 'password' : 'text'"
                  :label="$t('user.password.name')"
                  :hint="$t('user.password.hint')"
                  counter
                  :rules="passwordRules"
                  required
                  autocomplete="password"
                  data-cy="password" />
                <p class="mt-3 text-md-center font-weight-thin">{{ $t('login.manufacturers') }}</p>
              </v-col>

              <v-col class="d-flex justify-center">
                <v-btn type="submit" x-large color="primary" :loading="loggingUser">
                  {{ $t('login.login_button') }}
                </v-btn>
              </v-col>

              <v-col cols="12" class="text-center mt-2" v-if="loginError">
                <span class="red--text">{{ loginError }}</span>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-row>
    </v-card>

    <v-footer :padless="true" fixed>
      <v-card flat tile width="100%" color="#3B444F" class="lighten-1 text-right">
        <v-card-text>
          <v-menu :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="mx-4" icon>
                <v-icon color="white" size="24px"> mdi-web </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-for="language in languages" :key="language.code" @click="changeLanguage(language.code)">
                <v-list-item-avatar>
                  <country-flag :country="language.icon_code" />
                </v-list-item-avatar>
                <v-list-item-title>{{ language.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-text>
      </v-card>
    </v-footer>
    <v-snackbar v-model="snackbar" timeout="3000" color="red darken-2">
      <v-icon left color="white">mdi-alert-circle</v-icon>
      {{ $t('twoFactor.incorrect_or_expired_code') }}
      <template v-slot:action="{ attrs }">
        <v-btn text color="white" v-bind="attrs" @click="snackbar = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-container>

  <!-- !! MOBILE VIEW -->
  <v-container v-else class="d-flex justify-center align-center">
    <div class="text-center">
      <v-dialog v-model="isModalQR" max-width="700" scrollable persistent>
        <v-card style="max-height: 90vh">
          <v-card-text class="pa-0" style="overflow-y: auto">
            <TwoFactorQR
              :setup="twoFactorData"
              :email="loginEmail"
              @cancel="isModalQR = false"
              :user="loggedUser"
              :isMobile="isMobile" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-card class="d-flex px-4" style="margin-top: 4rem" elevation="10" height="100%">
      <v-row class="justify-center">
        <div class="mt-5">
          <v-img contain max-width="250" :src="logo"></v-img>
        </div>

        <v-card-text>
          <v-form @submit.prevent="validateUser()" ref="loginForm" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" class="px-8">
                <v-text-field v-model="loginEmail" label="Email" :rules="nameRules" required autocomplete="email" />
              </v-col>
              <v-col cols="12" class="px-8">
                <v-text-field
                  v-model="loginPassword"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (showPassword = !showPassword)"
                  :type="showPassword ? 'password' : 'text'"
                  :label="$t('user.password.name')"
                  :hint="$t('user.password.hint')"
                  counter
                  :rules="passwordRules"
                  required
                  autocomplete="password" />
              </v-col>

              <v-col class="d-flex justify-center">
                <v-btn type="submit" x-large color="primary" :loading="loggingUser">
                  {{ $t('login.login_button') }}
                </v-btn>
              </v-col>

              <v-col cols="12" class="text-center mt-2" v-if="loginError">
                <span class="red--text">{{ loginError }}</span>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-row>
    </v-card>

    <v-footer :padless="true" fixed>
      <v-card flat tile width="100%" color="#3B444F" class="lighten-1 text-right">
        <v-card-text>
          <v-menu :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="mx-4" icon>
                <v-icon color="white" size="24px"> mdi-web </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="language in languages" :key="language.code" @click="changeLanguage(language.code)">
                <v-list-item-avatar>
                  <country-flag :country="language.icon_code" />
                </v-list-item-avatar>
                <v-list-item-title>{{ language.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-container>
</template>

<script>
import router from '../plugins/router/index';
import userViewModel, { initializeTwoFactor } from '../viewModels/userViewModel';
import constants from '../plugins/lang/constants';
import TwoFactorQR from './twoFactorQR.vue';
import { eventBus } from '.././main';

export default {
  components: { TwoFactorQR },
  data: () => ({
    languages: constants.locales,
    showPassword: String,
    valid: false,
    alert: false,
    loginEmail: '',
    loginPassword: '',
    loggingUser: false,
    loginError: '',
    logo: require(process.env.VUE_APP_LOGO_COLOR),
    isModalQR: false,
    twoFactorData: null,
    snackbar: false,
    loggedUser: null,
    isTwoFactorEnabled: null,
  }),
  methods: {
    validateUser: async function () {
      const isValid = this.$refs.loginForm.validate();
      if (!isValid) return;

      try {
        this.loggingUser = true;
        this.loggedUser = await userViewModel.loginUserByEmail(this.loginEmail, this.loginPassword);

        this.loggingUser = false;
        this.loginError = '';
        this.isTwoFactorEnabled = this.loggedUser.restrictions?.features?.two_factor_auth?.enabled ?? true;

        userViewModel.SetEmail(this.loggedUser.email);
        if (!this.isTwoFactorEnabled) {
          userViewModel.SetToken(this.loggedUser.token);
          router.push({ name: 'dashboard' });
          return;
        }

        const payload = { email: this.loggedUser.email, token: this.loggedUser.token };
        this.twoFactorData = await initializeTwoFactor(payload);

        this.isModalQR = true;
      } catch (e) {
        if (e.code === 'INCORRECT_PASSWORD' || e.code === 'UNKNOWN_EMAIL') {
          this.loginError = this.$t('login.incorrect_credentials');
        } else {
          this.loginError = this.$t('login.error_ocurred');
          console.error('CATCH ERROR:', e);
        }
        this.loggingUser = false;
      }
    },

    changeLanguage(code) {
      userViewModel.changeUserLanguage(this, code);
    },

    setUserDefaultLanguage() {
      userViewModel.setLanguageToUserDefault(this);
    },
  },
  mounted() {
    this.setUserDefaultLanguage();
    eventBus.$on('incorrect_2fa_code', () => {
      this.snackbar = true;
    });
  },
  computed: {
    nameRules() {
      return [(text) => !!text || this.$t('login.error.empty_user')];
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    passwordRules() {
      return [
        (text) => !!text || this.$t('user.password.error.empty_password'),
        (text) => (text && text.length >= 5) || this.$t('user.password.error.invalid_password'),
      ];
    },
  },
};
</script>
<style scoped></style>
